import type { ComponentChildren } from "preact"
import { SiteFooter } from "./SiteFooter"

// The page frame the signed-out account pages share — email verification and
// both halves of password reset. There is no navbar out here, so the shell
// carries the wordmark and the one footer line itself.
//
// h-100 and not 100vh: the app shell is already 100dvh (styles.css), and
// 100vh on a phone is the viewport with the browser chrome retracted, i.e.
// taller than what you can see. min-height:100% on the inner box keeps the
// footer at the bottom of a short page while letting a tall one grow and
// scroll.
export function PublicShell({ children }: { children: ComponentChildren }) {
	return (
		<div class="h-100 overflow-auto">
			<div
				class="container page py-5"
				style="max-width: 34rem; min-height: 100%;"
			>
				<a href="/" class="plain inline-flex center gap-2 self-start">
					<img src="/static/brand/logo.svg" alt="" width="28" height="28" />
					<span class="brand-name">Quizfish</span>
				</a>
				{children}
				<div class="mt-auto">
					<SiteFooter />
				</div>
			</div>
		</div>
	)
}
